import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { showBanner, hideBanner } from 'common/ducks/banner';
import { fetchAll as fetchFocusGroups } from 'focus_groups/ducks/common';
import { fetchAll as fetchPresentations } from 'presentations/ducks';
import { getWrapups } from 'project/ducks/wrapup';
import {
  getProjectIdFromUrl, isCollaborator, getProjectUrl, canViewAllEntries, showPromoContent
} from 'project/utils';
import { getProject } from 'project/ducks/project';
import partial from 'lodash/partial';
import HeaderTabs from 'project/components/header_tabs';
import { getSubcategorySlug } from 'common/ducks/categories';

export function mapStateToProps(state, { router, routes }) {
  const project = getProject(state);
  const subcategory = getSubcategorySlug(state.categories, project.sub_category);
  const projectUrl = getProjectUrl(project, subcategory) || '';
  const user = state.user.profile_data;
  const userId = user.id;
  const isCreative = !!user.is_creative;
  const presentations = idx(state, _ => _.project.presentations.presentations) || [];

  return {
    project,
    projectUrl,
    router,
    presentations,
    wrapups: getWrapups(state),
    isCreative,
    isCollaborator: isCollaborator(project),
    isOwner: project.id && project.client === userId,
    isAuthenticated: !!userId,
    showEntries: canViewAllEntries(state),
    showPromoContent: showPromoContent({ user, project, routes })
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetchFocusGroups: partial(fetchFocusGroups, projectId),
    fetchPresentations: partial(fetchPresentations, projectId),
    showBanner,
    hideBanner
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderTabs));
